<template>
  <div>
    <a :href="`/items?scene_id=${sceneId}`">
      <div class="scenes-card">
        <div class="scenes-card-icon">
          <img :src="imageUrl" :alt="sceneName" />
        </div>
        <div class="scenes-card__info">
          <div class="scenes-card__title">{{ sceneName }}</div>
          <div class="scenes-card__description">{{ sceneDescription }}</div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    sceneId: {
      type: Number,
      required: true
    },
    sceneName: {
      type: String,
      required: true
    },
    sceneDescription: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  }
}
</script>
